import "./toolbar.scss";

import PropTypes from "prop-types";
import React from "react";
import ImmutablePropTypes from "react-immutable-proptypes";

import { immutableRecords, PropTypeShapes } from "../../types";
import ToolbarPopoverListGroup from "./ToolbarPopoverListGroup";

const ToolbarPopoverList = props => (
  <div className={`toolbarPopoverList ${props.showBorders ? "showBorders" : null}`}>
    {props.label ? <div className={`toolbarPopoverHeading`}>{props.label}</div> : null}
    {props.groups
      ? props.groups.map((g, index) => (
        <ToolbarPopoverListGroup
          key={index}
          {...g.toObject()}
          onClick={props.onClick}
          showIcons={props.showIcons}
          showSelectedIcon={props.showSelectedIcon}
          showSelectedBackground={props.showSelectedBackground}
          showShortcuts={props.showShortcuts}
          iconClass={props.iconClass}
          showDescription={props.showDescription}
        />
      ))
      : null}
    {props.children}
  </div>
);

ToolbarPopoverList.propTypes = {
  iconClass: PropTypes.string,
  showIcons: PropTypes.bool,
  showShortcuts: PropTypes.bool,
  showSelectedIcon: PropTypes.bool,
  showSelectedBackground: PropTypes.bool,
  showBorders: PropTypes.bool,
  groups: ImmutablePropTypes.listOf(PropTypes.instanceOf(immutableRecords.PopoverMenuGroupRecord)),
  onClick: PropTypes.func,
  label: PropTypes.string,
  showDescription: PropTypes.bool,
  children: PropTypeShapes.elementOrArray
};

export default ToolbarPopoverList;
